import { useGo } from "_utils/url";
import { $currentAttendanceId, $viewingAttendanceId } from "_pages/service/queue/state";
import { useAttendance, useFinishAttendance, useVideoAttendance } from "_api/hooks/attendances";
import { toastRun } from "_utils/misc";
import { E } from "_pages/service/queue/entity";
import { toastSuccess } from "_components/ToastProvider";
import { HStack, VStack } from "_ui/Box";
import { Divider } from "@mui/material";
import { Button } from "_ui/Button";
import { TimeDiff } from "./TimeDiff";
import { observer } from "@legendapp/state/react";
import Spinner from "_components/Spinner";
import { Attendance } from "_types/models/Attendance";
import { useEffect } from "react";
import { apiSwr, routes } from "_api";


const Video = ({ attendance }: { attendance: Attendance }) => {
    const meet = attendance.meet;
    const { mutateAsync: start, isPending: loading } = useVideoAttendance(attendance.id);

    useEffect(() => {
        setTimeout(() => {
            apiSwr.invalidateQueries({ queryKey: [...routes.attendance(attendance.id).show] });
        }, 1000 * 30);
    }, []);

    const startVid = async () => {
        await toastRun(start(), () => {
            window.open(meet.link, '_BLANK');
        });
    }

    if (!meet) {
        return (
            <VStack alignCenter>
                <dt>Video</dt>
                <Spinner size='xs' />
            </VStack>
        );
    }


    return (
        <Button text='Atendimento em video' icon="fa-video" onClick={startVid} {...{ loading }} />
    );
}

export const AttendanceInfo = observer(() => {
    const go = useGo();

    const attendanceId = $currentAttendanceId.get()!;
    const { attendance } = useAttendance(attendanceId);
    const { mutateAsync: finish } = useFinishAttendance(attendanceId!);

    const finishAttendance = async () => {
        await toastRun(
            finish(),
            () => {
                ($currentAttendanceId.set(undefined), $viewingAttendanceId.set(undefined))
                setTimeout(() => go(E.url.list));
                toastSuccess('Atendimento finalizado.');
                // setTimeout(() => ($currentAttendanceId.set(undefined), $viewingAttendanceId.set(undefined)), 100);
            }
        )
    }

    const time = attendance.startedAt;

    return (
        <HStack g={2} alignCenter center wrap>
            <span>{attendance.clientServed.name}</span>
            <Divider orientation='vertical' flexItem />
            <TimeDiff {...{ time }} />
            <Divider orientation='vertical' flexItem />

            <Video {...{ attendance }} />

            <Button text='Encerrar' variant='danger' icon='fa-power-off' onClick={finishAttendance} />
        </HStack>
    );
});
